import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const getRegistrationRequests = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/registrationrequests",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const approveRegistrationRequest = async (requestId, subsiteId) => {
  const response = await axios.post(
    process.env.REACT_APP_API_URL + "/admin/registrationrequest/approve/" + requestId,
    { subsiteId },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const denyRegistrationRequest = async (requestId, reason) => {
  const response = await axios.post(
    process.env.REACT_APP_API_URL + "/admin/registrationrequest/deny/" + requestId,
    { reason },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const addRegistrationRequest = async (data) => {
  // Extract recaptchaToken from data
  const { recaptchaToken, ...newRegistrationRequest } = data;

  const response = await axios.post(
    process.env.REACT_APP_API_URL + "/auth/registrationrequest",
    {
      newRegistrationRequest,
      recaptchaToken
    },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const RegistrationService = {
  getRegistrationRequests,
  approveRegistrationRequest,
  denyRegistrationRequest,
  addRegistrationRequest
};

export default RegistrationService;
